<template>
  <div>
    <v-dialog v-model="swalDialog" persistent></v-dialog>
    <v-data-table
      dense
      disable-sort
      :headers="headersTemplate"
      :items="list"
      height="auto"
      no-data-text="Sin resultados disponibles"
      fixed-header
      hide-default-footer
      :items-per-page="list.length"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              small
              class="mr-2"
              @click="
                get(
                  { idTemplateInterpretation: item.idTemplateInterpretation },
                  3
                )
              "
              v-bind="attrs"
              v-on="on"
            >
              mdi mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="red"
              small
              class="mr-2"
              @click="
                confirmationDelete({
                  idTemplateInterpretation: item.idTemplateInterpretation,
                })
              "
              v-bind="attrs"
              v-on="on"
            >
              mdi mdi-delete
            </v-icon>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
  },
  data() {
    return {
      swalDialog: false,
      headersTemplate: [
        { text: "Id Plantilla", value: "idTemplateInterpretation" },
        { text: "Nombre", value: "name" },
        { text: "Acciones", value: "actions", width: "20%" },
      ],
    };
  },
  methods: {
    confirmationDelete(value) {

      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea eliminar el registro?",
        // html: "¿Desea <b>regresar</b> a la vista principal?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;
          this.deleteItem(value);
        } else {
          this.swalDialog = false;
        }
      });
    },
  },
};
</script>

<style></style>
